import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeliveryChecklistRoutingModule } from './delivery-checklist-routing.module';
import { ChecklistSummaryComponent } from './checklist-summary/checklist-summary.component';
import { SharedModule } from '../shared/shared.module';
import { CreateDeliveryChecklistComponent } from './create-delivery-checklist/create-delivery-checklist.component';
import { VehicleCustomerDetailsComponent } from './create-delivery-checklist/vehicle-customer-details/vehicle-customer-details.component';
import { BdcSharedModule } from '../bdc/shared/bdc-shared.module';
import { DigiChecklistComponent } from './create-delivery-checklist/digi-checklist/digi-checklist.component';
import { SignaturePadComponent } from './create-delivery-checklist/signature-pad/signature-pad.component';
import { SignaturesComponent } from './create-delivery-checklist/signatures/signatures.component';
import { VinLookupModule } from './vin-lookup/vin-lookup.module';


@NgModule({
  declarations: [
    ChecklistSummaryComponent,
    CreateDeliveryChecklistComponent,
    VehicleCustomerDetailsComponent,
    DigiChecklistComponent,
    SignaturesComponent,
    SignaturePadComponent
  ],
  imports: [
    CommonModule,
    DeliveryChecklistRoutingModule,
    SharedModule,
    BdcSharedModule,
    VinLookupModule
  ]
})
export class DeliveryChecklistModule { }
